import React, { useEffect, useState } from 'react'
import ChartClearedImage from '../../../icons/chart-cleared.png'
import { getMediaUrl } from '../../../utils/utils'
import ChartName from './ChartName'
import ChartGrid from './ChartGrid'

const ChartCleared = ({
  chartData,
  completedHands,
  mistakenHands,
  matrixActions,
  colors,
  hand,
  restartChart,
}) => {
  const [animation, setAnimation] = useState({
    scale: 0,
    translate: '100vh',
    opacity: 0,
  })

  useEffect(() => {
    setAnimation({
      scale: 1,
      translate: 0,
      opacity: 1,
    })
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: animation.opacity,
      }}
    >
      <img
        alt=""
        style={{
          width: '400px',
          height: '200px',
          transform: `scale(${animation.scale})`,
          transition: 'transform 2000ms',
        }}
        src={getMediaUrl(ChartClearedImage)}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          transform: `translateY(${animation.translate})`,
          transition: 'transform 2000ms',
        }}
      >
        <ChartName chart={chartData} />
        <ChartGrid
          isGameOverMode={true}
          isSweeper={true}
          completedHands={completedHands}
          mistakenHands={mistakenHands}
          showRanges={true}
          showOutOfRange={true}
          matrixActions={matrixActions}
          colors={colors}
          hand={hand}
        />
        <div
          onClick={restartChart}
          style={{
            backgroundColor: '#0085FF',
            display: 'flex',
            width: '100%',
            borderRadius: '7px',
            padding: '10px',
            cursor: 'pointer',
            marginTop: '10px',
          }}
        >
          <div
            style={{
              color: 'white',
              fontFamily: ' Roboto, sans-serif',
              textTransform: 'uppercase',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Play Again
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChartCleared
